import { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { authMe, authSession } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/coach-login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    // strip the fragment so refresh doesn't re-process
    window.history.replaceState(null, "", window.location.pathname + window.location.search);
    authSession(sessionId)
      .then((data) => {
        navigate("/coach", { replace: true, state: { user: data.user } });
      })
      .catch((err) => {
        const detail = err?.response?.data?.detail || "Sign-in failed.";
        setError(detail);
      });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-brand-base flex flex-col items-center justify-center px-6 text-center">
      {error ? (
        <>
          <h2 className="font-serif text-3xl text-brand-ink">Sign-in not allowed</h2>
          <p className="mt-3 text-brand-ink-muted max-w-md">{error}</p>
          <button
            onClick={() => navigate("/coach-login", { replace: true })}
            className="btn-primary mt-8"
            data-testid="callback-back-btn"
          >
            Back to sign in
          </button>
        </>
      ) : (
        <>
          <Loader2 className="text-brand-primary animate-spin" size={32} strokeWidth={1.5} />
          <p className="mt-6 font-serif text-2xl text-brand-ink">Signing you in…</p>
        </>
      )}
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const location = useLocation();
  const [authState, setAuthState] = useState(
    location.state?.user ? { ok: true, user: location.state.user } : null
  );

  useEffect(() => {
    if (authState) return;
    let cancelled = false;
    authMe()
      .then((user) => { if (!cancelled) setAuthState({ ok: true, user }); })
      .catch(() => { if (!cancelled) setAuthState({ ok: false }); });
    return () => { cancelled = true; };
  }, [authState]);

  if (authState === null) {
    return (
      <div className="min-h-screen bg-brand-base flex items-center justify-center">
        <Loader2 className="text-brand-primary animate-spin" size={32} strokeWidth={1.5} />
      </div>
    );
  }
  if (!authState.ok) {
    return <Navigate to="/coach-login" replace state={{ from: location.pathname }} />;
  }
  return typeof children === "function" ? children(authState.user) : children;
}
